/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Size Converter`)
};

const es_ds_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Tamaño de Datos`)
};

const de_ds_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datengrößen-Konverter`)
};

const nl_ds_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Size Converter`)
};

const fr_ds_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de taille de données`)
};

const it_ds_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di dimensioni dei dati`)
};

const pt_br2_ds_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Tamanho de Dados`)
};

const pt_ds_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Tamanhos de Dados`)
};

const ja_ds_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データサイズ変換ツール`)
};

const zh_ds_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据大小转换器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_h1", locale)
	if (locale === "en") return en_ds_h1(inputs)
	if (locale === "es") return es_ds_h1(inputs)
	if (locale === "de") return de_ds_h1(inputs)
	if (locale === "nl") return nl_ds_h1(inputs)
	if (locale === "fr") return fr_ds_h1(inputs)
	if (locale === "it") return it_ds_h1(inputs)
	if (locale === "pt-BR") return pt_br2_ds_h1(inputs)
	if (locale === "pt") return pt_ds_h1(inputs)
	if (locale === "ja") return ja_ds_h1(inputs)
	return zh_ds_h1(inputs)
};